// extracted by mini-css-extract-plugin
export default {"dropBox":"DragAndDrop_dropBox__xm4DD"};